import React from 'react';
import { StyledButton, StyledContainer, StyledInput, StyledLabel, StyledOuterContainer, StyledIcon } from './index.styles.js';
import {} from '../icon/icon-names.generated.js';
import { Icon } from '../icon/index.js';
import {} from '@oneaudi/unified-web-common';
import { Popover } from '../popover/index.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Tag = ({ id, label, variant, onClick, icon, className, size, popover, name, defaultChecked, onChange, checked, value, disabled, margin, ...rest }) => {
    const resolvedSize = size ?? 'md';
    const iconSize = resolvedSize == 'md' ? 's' : 'xs';
    if (variant === 'read-only') {
        return (React.createElement(StyledContainer, { size: resolvedSize, className: className, variant: variant, margin: margin, ...pickA11yProps(rest), ...pickDataProps(rest) },
            icon && React.createElement(Icon, { size: iconSize, name: icon }),
            label));
    }
    if (variant === 'removable') {
        return (React.createElement(StyledContainer, { size: resolvedSize, className: className, variant: variant, margin: margin, ...pickDataProps(rest) },
            label,
            React.createElement(StyledButton, { onClick: onClick, ...pickA11yProps(rest) },
                React.createElement(StyledIcon, { size: iconSize, name: "cancel" }))));
    }
    if (variant === 'offer') {
        const getIcon = resolvedSize === 'md' ? 'special-offer-active' : 'special-offer';
        if (popover) {
            return (React.createElement(StyledOuterContainer, { size: resolvedSize, ...pickA11yProps(rest), ...pickDataProps(rest) },
                React.createElement(StyledContainer, null,
                    React.createElement(StyledIcon, { size: iconSize, name: getIcon }),
                    label),
                React.createElement(Popover, { alignment: popover.alignment, withTip: popover.withTip, open: popover.open, onClose: popover.onClose, content: popover.content, id: popover.id, triggerElement: React.createElement(StyledButton, { onClick: popover.onTriggerClick, "aria-label": popover.triggerAriaLabel },
                        React.createElement(StyledIcon, { name: "info-circle", size: iconSize })) })));
        }
        return (React.createElement(StyledContainer, { ...pickA11yProps(rest), ...pickDataProps(rest) },
            React.createElement(Icon, { size: iconSize, name: getIcon }),
            label));
    }
    const getIcon = () => {
        if (icon) {
            return React.createElement(Icon, { size: iconSize, name: checked ? 'select' : icon });
        }
        if (checked) {
            return React.createElement(Icon, { size: iconSize, name: 'select' });
        }
        return;
    };
    return (React.createElement(StyledLabel, { className: className, ...pickDataProps(rest), margin: margin },
        React.createElement(StyledContainer, { variant: variant, size: resolvedSize, disabled: disabled },
            React.createElement(StyledInput, { value: value, type: "checkbox", name: name, defaultChecked: defaultChecked, onChange: onChange, onClick: onClick, checked: checked, disabled: disabled, id: id, ...pickA11yProps(rest) }),
            getIcon(),
            label)));
};
//# sourceMappingURL=index.js.map